import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { Button, Space, Steps } from 'antd';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../../components/core/BreadCrumbs';
import { APP_TERMS } from '../../../app-terms';
import PatientDetails from './PatientDetails';
import StudyPurpose from './StudyPurpose';
import AddServices from './AddService';
import UploadFiles from './UploadFiles';
import { useServicesList } from '../../../hooks/services/useServicesList';

const FormLayout = forwardRef(function FormLayout(
  {
    patientDetailsForm,
    studyPurposeForm,
    addServiceForm,
    uploadFilesForm,
    loading,
    breadCrumbs,
  },
  ref
) {
  const { data: servicesList, getServicesList } = useServicesList();
  const [activeTab, setActiveTab] = useState(0);

  const goToPrevTab = () => setActiveTab((value) => value - 1);
  const goToNextTab = () => setActiveTab((value) => value + 1);

  const handleSubmit = (index) => {
    switch (index) {
      case 0:
        patientDetailsForm?.submit();
        break;
      case 1:
        studyPurposeForm?.submit();
        break;
      case 2:
        addServiceForm?.submit();
        break;
      case 3:
        uploadFilesForm?.submit();
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    // Fetch services list
    getServicesList();
  }, []);

  useImperativeHandle(ref, () => ({
    goToNextTab,
  }));

  return (
    <div>
      <div>
        <BreadCrumbs items={breadCrumbs} />
        <div className="row card">
          <div className="card invoices-tabs-card">
            <div className="card-body card-body pt-0 pb-0">
              <div className="invoices-main-tabs">
                <div className="row align-items-center">
                  <div className="wizard mt-4">
                    <ul
                      className="nav nav-tabs justify-content-center"
                      role="tablist"
                    >
                      <Steps
                        current={activeTab}
                        items={[
                          {
                            title: `${APP_TERMS.generic_patients} ${APP_TERMS.generic_details}`,
                            icon: <i className="far fa-user"></i>,
                          },
                          {
                            title: `${APP_TERMS.generic_study} ${APP_TERMS.generic_purpose}`,
                            icon: <i className="fa fa-stethoscope"></i>,
                          },
                          {
                            title: `${APP_TERMS.generic_add} ${APP_TERMS.generic_services}`,
                            icon: <i className="fa fa-bars"></i>,
                          },
                          {
                            title: `${APP_TERMS.generic_upload} ${APP_TERMS.generic_files}`,
                            icon: <i className="fa fa-file"></i>,
                          },
                        ]}
                      />
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                {activeTab == 0 && <PatientDetails form={patientDetailsForm} />}
                {activeTab == 1 && <StudyPurpose form={studyPurposeForm} />}
                {activeTab == 2 && (
                  <AddServices
                    form={addServiceForm}
                    servicesList={servicesList}
                  />
                )}
                {activeTab == 3 && <UploadFiles form={uploadFilesForm} />}
              </div>

              <Space className="mt-3">
                {activeTab === 3 ? (
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="button"
                    onClick={() => handleSubmit(activeTab)}
                  >
                    Save
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    htmlType="button"
                    disabled={loading}
                    onClick={() => handleSubmit(activeTab)}
                  >
                    Next
                  </Button>
                )}
                {activeTab > 0 ? (
                  <Button
                    htmlType="button"
                    disabled={loading}
                    onClick={goToPrevTab}
                  >
                    Previous
                  </Button>
                ) : null}
              </Space>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

FormLayout.propTypes = {
  patientDetailsForm: PropTypes.any,
  studyPurposeForm: PropTypes.any,
  addServiceForm: PropTypes.any,
  uploadFilesForm: PropTypes.any,
  loading: PropTypes.bool,
  breadCrumbs: PropTypes.array,
};

export default FormLayout;
